<div class="headerbar">
  <div class="navbar_space">
    <div class="header_part">
      <div class="header_part_left">
        <div class="header_part_right_menu">
        </div>
      </div>
      <div class="header_part_right">
        <div class="search-container" [class.active]="searchLeadText || isFocused" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
          <input type="text" class="search-input form-control" placeholder="Search Lead..." (keydown.enter)="searchLead()" [(ngModel)]="searchLeadText"  (focus)="onFocus()" (blur)="onBlur()" />
          <span class="search-icon">
            <i *ngIf="searchLeadText" class="bi bi-x-lg mr-2" (click)="clearText()"></i>
            <i class="bi bi-search" (click)="searchLead()"></i> <!-- Search Icon -->
          </span>
        </div>
        <div class="header_part_right_user">
          <!-- <img [src]="bucketurl + '/images/notify.png'" (click)="toggleDropdown()"> -->
          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item" placement="bottom-right">
              <a class="nav-link pr-0" role="button">
                <div class="media align-items-center">
                  <div class="media-body ml-2 d-none d-lg-block noti" (click)="openNotification()">
                    <span class="mb-0 text-sm"><img [ngClass]="{'bell-icon': notificationCount}"
                        [src]="bucketurl + '/images/notify.png'"></span>
                    <span class="notification-count" *ngIf="notificationCount != 0">{{notificationCount}}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <!-- <div class="header_part_right_logout"><img [src]="bucketurl + '/images/user.png'"> </div> -->
        <div class="header_part_right_name">
          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item" ngbDropdown placement="bottom-right">
              <a class="nav-link pr-0" role="button" ngbDropdownToggle>
                <div class="media align-items-center">
                  <div class="media-body ml-2 d-none d-lg-block">
                    <img style="width: 20px;margin-right: 5px;" src="/assets/images/person.png"> <span
                      class="mb-0 text-sm">{{username}}</span>
                  </div>
                </div>
              </a>
              <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
                <div class=" dropdown-header noti-title">
                  <h6 class="drop-head">Welcome!</h6>
                </div>
                <a [routerLink]="['../suzuki/user-profile']" class="dropdown-item mb-2">
                  <img src="/assets/images/user_2.png" class="profile mr-2" alt="">
                  <span class="drop-text">My profile</span>
                </a>
                  <a [routerLink]="['../suzuki/email-settings']" class="dropdown-item mb-2">
                  <img src="/assets/images/settings.png" class="profile mr-2" alt="">
                  <span class="drop-text">Email Settings</span>
                </a>
                <a [routerLink]="['../suzuki/change-password']" class="dropdown-item mb-2">
                  <img src="/assets/images/settings.png" class="profile mr-2" alt="">
                  <span class="drop-text">Reset Password</span>
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" (click)="openDialog(logout_pop)">
                  <img src="/assets/images/log-out.png" class="profile mr-2" alt="">
                  <span class="drop-text">Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template id="logout_pop" #logout_pop>
  <div class="modal-body">
    <div class="row mt-2">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="submission_success">
          <p style="text-align: center;font-weight: 500;">
            <span><img style="width: 17px;margin-right: 7px;" src="/assets/images/alert-triangle.png" /></span>
            Are you sure want to logout?
          </p>
        </div>
        <div class="col-12 text-center mt-3">
          <button class="btn mr-2" (click)="closeDialog()">No</button>
          <button class="btn blue-btn " (click)="logOut()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>